import React, { useState, useMemo } from "react";
import { Table, Button } from "antd";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import Surface from "../../components/layouts/Surface";
import Header from "./components/Header";
import { CheckOutlined } from "@ant-design/icons";
import getDayCenterColumns from "./components/columns";
import DayCenterPatientModal from "./components/DayCenterPatientModal";
import useDayCenterData from "./components/useDayCenterData";
import moment from "moment";
import { useDispatch } from "react-redux";
import { setDate } from "../dayCenterPatient/dayCenterPatientSlice";
import { setActivePatient } from "../dayCenterPatient/dayCenterPatientSlice";
import { usePermission } from "../../hooks/accessControl";
import { setActiveBranch } from "../dayCenter/dayCenterSlice";
import { useLocation, useParams } from "react-router-dom";

const DayCenter = () => {
  const intl = useIntl();
  let { branchId } = useParams();

  let location = useLocation();
  const [record, setRecord] = useState(false);
  const activeDate = useSelector((state) => state.dayCenter.activeDate);
  const loading = useSelector(
    (state) => state.pendingActions["dayCenter/update_records"]
  );
  const branch = useSelector((state) => state.dayCenter.activeBranch);
  const activeBranch = branchId || branch;
  const dispatch = useDispatch();

  const showModal = (val) => {
    dispatch(setDate({ date: val.date }));
    setRecord(val);
  };

  const {
    changes,
    isLoading,
    data,
    handleChanges,
    updateServer,
    onChange,
    onTextChange,
    refetch,
  } = useDayCenterData(activeDate, activeBranch);
  const hasEditorPermission = usePermission(
    activeBranch,
    "day_center",
    "editor"
  );

  const hasPatientsPermission = usePermission(
    activeBranch,
    "patients",
    "viewer"
  );
  const handleCancel = () => {
    setRecord(null);
    dispatch(setActivePatient(null));
    refetch();
  };

  const columns = useMemo(
    () =>
      getDayCenterColumns(
        intl,
        handleChanges,
        changes,
        showModal,
        hasEditorPermission,
        hasPatientsPermission,
        location
      ),
    [intl, handleChanges, changes, showModal, activeDate, activeBranch, data]
  );

  const isDateAfterToday = moment(activeDate).isAfter(moment(), "day");

  return (
    <Surface>
      <Header
        onBranchChange={(branch) => {
          dispatch(setActiveBranch({ branch }));
          // console.log(branch);
          // return setBranch_id(branch);
        }}
        branch_id={activeBranch}
        onTextChange={onTextChange}
      />
      <div style={{ height: "10px" }} />
      <Table
        id={"dayCenterTableRef"}
        bordered
        columns={columns}
        dataSource={data}
        rowKey={(record) => record.id}
        scroll={{ y: window.innerHeight - 396 }}
        onChange={onChange}
        pagination={false}
        loading={isLoading}
      />
      <Button
        type="primary"
        style={{ position: "absolute", bottom: "34px" }}
        onClick={updateServer}
        icon={<CheckOutlined />}
        disabled={
          Object.keys(changes).length === 0 ||
          isDateAfterToday ||
          !hasEditorPermission
        }
        loading={loading}
      >
        {" " +
          intl.formatMessage({
            id: "app.actions.saveChanges",
          })}
      </Button>
      <DayCenterPatientModal
        visible={record}
        onCancel={handleCancel}
        record={record}
      />
    </Surface>
  );
};

export default DayCenter;
